import Vue from 'vue';
import Router from 'vue-router';

declare module 'vue/types/vue' {
  // 3. Declare augmentation for Vue
  interface Vue {
    $alerts: Alerts,
    $alert: (alert: any) => void,
  }
}

export interface Alert {
  type: 'error' | 'info',
  message: string,
  body?: string,
  id?: number,
  count: number,
}

interface State {
  all: {
    [key: string]: Alert
  }
}
export class Alerts extends Vue {
  state: State = Vue.observable({
    all: {},
  });

  create(alert: any) {
    console.log(alert);
    if (typeof alert === 'string') {
      alert = {
        type: 'error',
        message: alert,
      };
    } else if (typeof alert === 'object' && alert) {
      if (!alert.type) {
        alert.type = 'error';
      }
      if (!alert.message) {
        alert.message = JSON.stringify(alert);
      }
    } else {
      alert = {
        type: 'error',
        message: JSON.stringify(alert),
      };
    }
    const previous = Object.values(alerts.state.all).pop();
    if (
      previous
      && alert.type === previous.type
      && alert.message === previous.message
      && alert.body === previous.body
    ) {
      previous.count += 1;
      return previous;
    }
    alert.count = 1;
    alert.id = Date.now();
    Vue.set(alerts.state.all, alert.id, alert);
  }

  dismiss(id: string) {
    Vue.delete(alerts.state.all, id);
  }
}

const alerts = new Alerts();

export default function install(Vue?: Vue.VueConstructor) {
  if (Vue) {
    Vue.prototype.$alerts = alerts;
    Vue.prototype.$alert = alerts.create;
    Vue.component('alerts', require('./components/Alerts.vue').default);
    (window as any).alerts = alerts;
  }
  return alerts;
}
